<template>
  <div id="app">
    <router-view />
    <dialog-kf></dialog-kf>
    <MinappPopup v-if="!isAdmin"></MinappPopup>
  </div>
</template>

<script>
import DialogKf from '@cps/DialogKf';
import { initAdminColor } from '@/utils/themeColorClient';
import MinappPopup from '@cps/MinappPopup'
import { getRoles } from '@/utils/auth';
const roles = getRoles() || [];


export default {
  name: 'App',
  components: {
    DialogKf,
    MinappPopup,
  },
  data: () => ({
    isAdmin: roles[0] === 'admin',
  }),
  computed: {
    roles() {
      return this.$store.state.user.roles[0];
    },
  },
  watch: {
    roles(val) {
      if (val === 'admin') {
        initAdminColor();
      }
    },
  },
  mounted() {
    if (this.$store.state.user.roles[0] === 'admin') {
      initAdminColor();
    }
  },
};
</script>

